import { unitRegistry } from './instance';

const { presentationKeys, presentationInputUnitsByKey } = unitRegistry;

export type DisplayTarget = {
  presentationKey?: string;
  transformTarget?: string;
};

/**
 * Resolves displayUnits into the presentation key that owns formatting (if any)
 * and the unit to convert toward. `inputUnits` overrides the target; otherwise the
 * presentation key passes through, because label-set transformers (boolean/on-off/
 * open-closed) select their labels from it.
 */
export function resolveDisplayTarget(displayUnits?: string): DisplayTarget {
  if (displayUnits == null) {
    return {};
  }

  const key = displayUnits.toLowerCase();

  if (!presentationKeys.has(key)) {
    return { transformTarget: displayUnits };
  }

  return {
    presentationKey: key,
    transformTarget: presentationInputUnitsByKey[key] ?? displayUnits,
  };
}
